import styled from "@emotion/styled";
import { FC, PropsWithChildren } from "react";
import { Box, Divider } from "@mui/material";

const Container = styled.div`
  margin: 32px auto 0;
  width: 90%;
`;

const HomeFormButtons: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Container>
      <Divider variant="fullWidth" flexItem />
      <Box
        display="flex"
        justifyContent="flex-end"
        margin="32px auto 0"
        width="90%"
      >
        {children}
      </Box>
    </Container>
  );
};

export default HomeFormButtons;
